//Libraries
import styled from 'styled-components'

type ContainerProps = {
  flex?: 'row' | 'column'
  align?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-evenly'
  justify?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-evenly'
  margin?: string
}

export const Aligner = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: ${({ flex }) => flex || 'row'};
  align-items: ${({ align }) => align || 'initial'};
  justify-content: ${({ justify }) => justify || 'initial'};
  margin: ${({ margin }) => margin || 0};
`

export const Main = styled.main`
  width: 100%;
  min-height: calc(100vh-72px);
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    min-height: calc(100vh-78px);
  }
`

export const PaddingContainer = styled.div<ContainerProps>`
  width: 100%;
  max-width: 1440px;
  padding: 0 32px;
  display: flex;
  flex-direction: ${({ flex }) => flex || 'row'};
  margin: ${({ margin }) => margin || '0 auto'};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    margin: ${({ margin }) => margin || '0 auto'};
    padding: 0px 114px;
  }
`

export const SimpleContainer = styled.div``
